var _title, _polygon;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgNavigateDown = props => /*#__PURE__*/React.createElement("svg", _extends({
  width: "10px",
  height: "6px",
  xmlns: "http://www.w3.org/2000/svg",
  xmlnsXlink: "http://www.w3.org/1999/xlink"
}, props), _title || (_title = /*#__PURE__*/React.createElement("title", null, "Atom/Icon/System/navigate-up")), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
  id: "Path",
  points: "5.25 6.044425 0.22815 0.7583 0.77185 0.2417 5.25 4.955575 9.72815 0.2417 10.27185 0.7583"
})));
export { SvgNavigateDown as ReactComponent };